export enum ChipSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg'
}
export enum ChipVariant {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
  low = 'low',
  high = 'high',
  mid = 'mid',
  default = 'default'
}
